import apiClient from "./axios.config";

const propertyService = {
  getPropertyListing(payload) {
    return apiClient.post("/website/property/listings", payload);
  },

  //new endpoint to list the property with dynamic Location Details
  getPropertyListingWithMetaDetails(payload) {
    return apiClient.post(
      "/website/property/listings/with-location-seo",
      payload,
    );
  },

  getFeaturedProperty() {
    return apiClient.get("/website/property/featured");
  },
  getNewlyProperty() {
    return apiClient.get("/website/property/newly-arrived");
  },
  getFastSellingProperty() {
    return apiClient.get("/website/property/fast-selling");
  },

  getPropertyLocations() {
    return apiClient.get("/website/property/locations");
  },

  getPropertyDetail(payload) {
    return apiClient.get(`/website/property-detail?flatId=${payload.flatId}`);
  },

  getLocationSuggestions(payload) {
    return apiClient.get(
      `/website/property/locations/autocomplete?locName=${payload.locName}`,
    );
  },
  getBhkTypes() {
    return apiClient.get("/website/property/bhk-types");
  },
};

export default propertyService;
